<template>
    <div v-if="value">
        <d-recipients-edit
            v-model       = "edit"
            :recipient-id = "company.id"
            :customer-id  = "company.parent.id"
            @saved        = "onSaved"
        />

        <c-list-card
            :icon            = "icon"
            :edit            = "enableEdit"
            :drag-data       = "value"
            :highlight-color = "highlightColor"
           :background       = "background"
            :drag-type       = "dragData"
            @edit            = "onEdit"
            @selected        = "onSelect"
        >
            <template v-slot:title>
                <div class="w-100 v-flex">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                v-bind = "attrs"
                                v-on   = "on"
                                class  = "card-title"
                            >
                                {{ value.id }} - {{ value.name }}
                            </div>
                        </template>
                        <div>
                            {{ value.id }} - {{ value.name }}
                        </div>
                    </v-tooltip>
                </div>
            </template>

            <template v-slot:toolbar>
                <slot name="toolbar"></slot>
            </template>
            <template v-slot:body>
                <div>
                    <v-row class="no-frame mt-1">
                        <v-col class="no-frame">
                            <div
                                class  = "card-name"
                                v-html = "toHtml (value.nameAdd)"
                                v-if   = "value.nameAdd"
                            />
                            <div class="card-subtitle">
                                {{ value.street }}
                            </div>
                            <div class="card-subtitle">
                                {{ value.zip }}  {{ value.city }}
                            </div>
                        </v-col>
                        <v-col class="no-frame col-auto">
                            <div v-if="value.dtype === 5" class="mt-1">
                                <c-tag
                                    :width            = "tagwidth"
                                    :background-color = "highlightColor"
                                    :label            = "$t('msd.recipient.limshort')"
                                    :active           = "value.liftmanagement"
                                />
                                <c-tag
                                    :width            = "tagwidth"
                                    :background-color = "highlightColor"
                                    :label            = "$t('msd.recipient.incmanagement')"
                                    :active           = "value.incidentmanagement"
                                />
                                <c-tag
                                    :width            = "tagwidth"
                                    :background-color = "highlightColor"
                                    :label            = "$t('msd.recipient.incident')"
                                    :active           = "value.usedOnIncidents"
                                    class             = "mr-1"
                                />
                                <c-tag
                                    :width            = "tagwidth"
                                    :background-color = "highlightColor"
                                    :label            = "$t('msd.recipient.costs')"
                                    :active           = "value.usedOnCosts"
                                    class             = "mr-1"
                                />
                                <c-tag
                                    :width            = "tagwidth"
                                    :background-color = "highlightColor"
                                    :label            = "$t('msd.recipient.repair')"
                                    :active           = "value.usedOnRepair"
                                    class             = "mr-1"
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </c-list-card>
    </div>
</template>

<script>

import CListCard from "@/modules/core/components/utils/CListCard";
import CTag      from "@/modules/core/components/utils/CTag";
import Core from "@/modules/core/service/Core";
import DRecipientsEdit from "@/modules/msd/company/recipient/components/DRecipientsEdit";

export default {
    name: "CRecipientCard",
    components: {
        DRecipientsEdit,
        CTag,
        CListCard,
    },

    props: {
        company: {
            required: false,
            type    : Object,
            default: function () {
                return null;
            }
        },

        enableEdit: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        highlightColor: {
            required: false,
            type    : String,
            default : function () {
                return "primary";
            }
        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return "white";
            }
        }

    },

    data: () => ({
        edit: false,
        value: {
            liftmanagement    : false,
            incidentmanagement: false,
            dtype             : null,
            nameAdd           : null,
            usedOnIncidents   : null,
            usedOnCosts       : null,
            usedOnRepair      : null
        },
        tagwidth: 110,
    }),

    watch: {
        company: {
            deep: true,
            handler: function () {
                this.value = this.company;
            }
        }
    },

    computed: {
        icon () {
            let icon = {
                label     : "",
                active    : true,
                background: this.highlightColor
            };

            if (this.value.invoice) {
                icon.label = icon.label + "R";
            }

            if (this.value.benefit) {
                icon.label = icon.label + "L";
            }

            return icon;
        },

        dragData () {
            return {
                type: "recipient",
                data: this.entry
            };
        },
    },

    mounted() {
        this.value = this.company;
    },

    methods: {
        onEdit () {
            this.edit = true;
        },

        onSelect () {
            Core.fire.selected(this, this.value);
        },

        onSaved (company) {
            this.value = company;
            Core.fire.selected(this, company);
        },

        toHtml (text) {
            return Core.format.html(text);
        }
    }
}
</script>

<style scoped>

.card-name {
    font-size: 13px;
    margin-bottom: 15px;
}

.card-subtitle {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.card-title {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


</style>